'use client';

import IconButton from '@mui/material/IconButton';
import { useModal } from '@prismo-io/design-system';
import type { FC } from 'react';
import { AiFillEdit } from 'react-icons/ai';

export const FormModalOpenBtn: FC = () => {
  const { onOpen } = useModal();

  return (
    <IconButton onClick={onOpen} size="small">
      <AiFillEdit fontSize="small" />
    </IconButton>
  );
};
